import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { NavService } from '../../services/nav.service';
import { PencilButtonComponent } from '../../standalones/components/pencil-button/pencil-button.component';
import { IconTypes } from '../../standalones/components/pencil-icon/pencil-icon.component';
import { UiModule } from '../ui.module';

export type TopBarVariant = 'gray' | 'solid';

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [CommonModule, UiModule, PencilButtonComponent],
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarComponent {
  @Input() title?: string | null;
  @HostBinding('class') @Input() variant: TopBarVariant = 'solid';

  protected readonly IconTypes = IconTypes;

  constructor(private readonly navService: NavService) {}

  onMenuClick(): void {
    this.navService.isMenuOpened.next(true);
  }
}
